import { IconCaretUpDownFilled, IconCaretDownFilled, IconCaretUpFilled, Icon } from '@tabler/icons-react';
import type { SortingIconProps } from 'components/DraggableTable/DraggableHeader/SortingIcon/SortingIcon';
import { ColSortConfig, SortDirection } from 'types/sort';

export const getSortIcon = <T>(key: T, config?: ColSortConfig<T>): Icon => {
    if (!config || config.key !== key) {
        return IconCaretUpDownFilled;
    }
    switch (config.direction) {
        case SortDirection.ASC:
            return IconCaretUpFilled;
        case SortDirection.DESC:
            return IconCaretDownFilled;
        default:
            return IconCaretUpDownFilled;
    }
};

export const getSortingIconProps = <T>(
    key: T,
    config: ColSortConfig<T> | undefined,
    setConfig: (config: ColSortConfig<T> | undefined) => void,
): SortingIconProps => ({
        columnId: String(key),
        isSorted: config?.key === key,
        sortedDirection: config?.key === key
            ? (config.direction === SortDirection.ASC ? 'asc' : 'desc')
            : null,
        onAscendingSort: () => setConfig({ key, direction: SortDirection.ASC }),
        onDescendingSort: () => setConfig({ key, direction: SortDirection.DESC }),
        // Third click clears the sort, giving an ASC → DESC → unsorted cycle.
        onClearSort: () => setConfig(undefined),
    });
